import { MailOutlined } from "@ant-design/icons";
import { Button } from "antd";

function ReportCardV2({
  icon,
  title,
  detail,
  status,
  onViewClick,
  onConfigureClick,
  configureButtonProps = {}
}: {
  icon: any;
  title: string;
  detail: any;
  status?: React.ReactNode | string;
  onViewClick: () => void;
  onConfigureClick: () => void;
  configureButtonProps?: {
    disabled?: boolean;
  };
}) {
  return (
    <div className="flex flex-col w-[319px] h-[380px] rounded border-solid border-ciq-gray-100 border mt-5 bg-white">
      <div
        className="w-full font-medium text-sm items-center py-2 px-3 border-0 border-b border-solid border-ciq-gray-100"
        data-testid="report-card-title"
      >
        {title}
      </div>
      <div className="grow">
        <div className="h-full px-4" data-testid="report-card-body">
          <div className="p-1 py-6 text-center">{icon}</div>
          <div className="px-1 text-sm">{detail}</div>
        </div>
      </div>
      {status ? (
        <div className="px-4" data-testid="report-card-status">
          {status}
        </div>
      ) : null}
      <div className={`p-4 flex gap-2 ${status ? "pt-2" : ""}`}>
        <Button
          type="primary"
          className="flex-1"
          onClick={onViewClick}
          data-testid="report-card-view-button"
        >
          View
        </Button>
        <Button
          className="flex-1"
          onClick={onConfigureClick}
          data-testid="report-card-configure-button"
          {...configureButtonProps}
        >
          <MailOutlined className="text-black text-opacity-40" /> Configure
        </Button>
      </div>
    </div>
  );
}
export default ReportCardV2;
